import {
  getChatProcessingStatusMessage,
  type ChatProcessingStatusInput,
} from '../utils/getChatProcessingStatusMessage';

export type ChatStatusAnnouncerProps = ChatProcessingStatusInput;

/**
 * Announces the AI processing state to screen readers. Always mounted, since a live region must
 * exist before its content changes.
 */
export function ChatStatusAnnouncer({ isLoading, isWaitingForDocumentProcessing, messages }: ChatStatusAnnouncerProps) {
  const status = getChatProcessingStatusMessage({ isLoading, isWaitingForDocumentProcessing, messages });

  return (
    <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
      {status}
    </div>
  );
}
